import { createEmptySlide, SLIDE_LAYOUTS, normalizeSlide } from './slideSchema';

/**
 * Templates institucionais para o Workspace ARCA.
 * Conteúdo editável — branding visual via tema do slide.
 */
export const ARCA_TEMPLATES = [
  {
    id: 'capa',
    label: 'Capa',
    description: 'Abertura institucional',
    build: () =>
      normalizeSlide({
        ...createEmptySlide(),
        layout: SLIDE_LAYOUTS.TITULO_CENTRO,
        titulo: 'Título da Apresentação',
        subtitulo: 'Unidade · Setor de Contratos · SGC',
        bullets: [''],
        tipografia: {
          fontFamily: '"Segoe UI", system-ui, sans-serif',
          tituloSize: 36,
          subtituloSize: 18,
          bulletSize: 15,
          boldTitulo: true,
          align: 'center',
        },
        meta: { template: 'capa' },
      }),
  },
  {
    id: 'agenda',
    label: 'Agenda',
    description: 'Pauta da reunião',
    build: () =>
      normalizeSlide({
        ...createEmptySlide(),
        layout: SLIDE_LAYOUTS.TITULO_BULLETS,
        titulo: 'Agenda',
        subtitulo: 'Pontos de pauta',
        bullets: [
          'Abertura e objetivos',
          'Indicadores do período',
          'Pendências e riscos',
          'Decisões e próximos passos',
        ],
        tipografia: {
          fontFamily: '"Segoe UI", system-ui, sans-serif',
          tituloSize: 28,
          subtituloSize: 16,
          bulletSize: 16,
          boldTitulo: true,
          align: 'left',
        },
        meta: { template: 'agenda' },
      }),
  },
  {
    id: 'kpi',
    label: 'KPI / Indicadores',
    description: 'Slide com gráfico',
    build: () =>
      normalizeSlide({
        ...createEmptySlide(),
        layout: SLIDE_LAYOUTS.TITULO_BULLETS,
        titulo: 'Indicadores do período',
        subtitulo: 'Visão executiva',
        bullets: [
          'Contratos ativos na unidade',
          'Vencimentos nos próximos 90 dias',
          'Ações prioritárias do setor',
        ],
        graficos: [
          {
            id: `chart_${Date.now()}`,
            titulo: 'Distribuição ilustrativa',
            tipo: 'bar',
            labels: ['Ativos', 'Vencendo', 'Finalizados'],
            valores: [42, 8, 12],
          },
        ],
        tipografia: {
          fontFamily: '"Segoe UI", system-ui, sans-serif',
          tituloSize: 26,
          subtituloSize: 15,
          bulletSize: 14,
          boldTitulo: true,
          align: 'left',
        },
        meta: { template: 'kpi' },
      }),
  },
  {
    id: 'encerramento',
    label: 'Encerramento',
    description: 'Próximos passos',
    build: () =>
      normalizeSlide({
        ...createEmptySlide(),
        layout: SLIDE_LAYOUTS.TITULO_CENTRO,
        titulo: 'Próximos passos',
        subtitulo: 'Obrigado · Perguntas e alinhamentos',
        bullets: [''],
        tipografia: {
          fontFamily: '"Segoe UI", system-ui, sans-serif',
          tituloSize: 34,
          subtituloSize: 17,
          bulletSize: 15,
          boldTitulo: true,
          align: 'center',
        },
        meta: { template: 'encerramento' },
      }),
  },
];

export function getTemplateById(id) {
  return ARCA_TEMPLATES.find((t) => t.id === id) || null;
}
